{
  "steps": {
    "usage":            "¿Para qué vas a utilizar Khronox?",
    "manage":           "¿Qué te gustaría gestionar?",
    "orgName":          "¿Cómo te gustaría llamar tu primera organización?",
    "features":         "¿Qué funciones te gustaría probar?",
    "taskOrganization": "¿Cómo quieres organizar tus tareas?",
    "inviteMembers":    "Invita a colaboradores a tu organización:"
  },
  "usage": {
    "personal":  "Uso personal",
    "team":      "Equipo pequeño",
    "company":   "Empresa",
    "freelance": "Freelance"
  },
  "manage": {
    "projects": "Proyectos",
    "tasks":    "Tareas",
    "team":     "Equipo",
    "clients":  "Clientes"
  },
  "features": {
    "tasks":       "Tareas y proyectos",
    "automations": "Automatizaciones",
    "goals":       "Metas",
    "chat":        "Chat",
    "sprints":     "Sprints",
    "docs":        "Documentos",
    "calendar":    "Calendario",
    "crm":         "CRM",
    "gantt":       "Cronogramas",
    "flowchart":   "Diagramas de flujo",
    "time":        "Registro de tiempo",
    "forms":       "Formularios",
    "workload":    "Carga de trabajo",
    "ai":          "IA"
  },
  "taskOrganization": {
    "board":    "Tablero Kanban",
    "list":     "Lista",
    "calendar": "Calendario",
    "gantt":    "Gantt"
  },
  "navigation": {
    "back":     "Volver",
    "next":     "Siguiente",
    "finish":   "Finalizar",
    "skip":     "Saltar",
    "saving":   "Guardando..."
  },
  "invite": {
    "placeholder": "Escribe o pega las direcciones de correo electrónico",
    "hint":        "Presiona Enter o coma para agregar varios correos",
    "remove":      "Eliminar {{email}}",
    "errors": {
      "invalid":    "Introduce un correo válido",
      "duplicate":  "Este correo ya fue agregado"
    }
  },
  "orgName": {
    "placeholder": "Nombre de la organización"
  },
  "title":    "Configuración inicial de tu organización",
  "welcome":  "¡Bienvenido a Khronox, {{name}}!",
  "error":    "Algo salió mal. Inténtalo de nuevo."
}